module.exports = __webpack_public_path__ + "static/media/services_arrow.968f4506.svg";